import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { usePrivacyPolicy } from '../../hooks/usePrivacyPolicy';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { useTranslatedContent } from '../../hooks/useTranslatedContent';

interface PrivacyPolicyLinkProps {
  config: any;
  rgpdConfig: any[];
}

export const PrivacyPolicyLink: React.FC<PrivacyPolicyLinkProps> = ({
  config,
  rgpdConfig
}) => {
  const { i18n } = useTranslation();
  const {
    policy,
    isModalOpen,
    openModal,
    closeModal,
    getLastUpdate,
    isLoading
  } = usePrivacyPolicy();

  const terms = useMemo(() => ['privacy_policy'], []);
  const { translations } = useTranslatedContent({ terms });

  const getTranslatedText = useCallback((key: string): string => {
    const translation = translations?.[key];
    if (!translation) return key;
    return translation[i18n.language] || translation.fr || key;
  }, [translations, i18n.language]);

  if (isLoading || !policy) return null;

  return (
    <>
      <button
        onClick={openModal}
        className="hover:underline"
        style={{ color: config['light-color'] }}
      >
        {getTranslatedText('privacy_policy')}
      </button>

      {isModalOpen && (
        <PrivacyPolicyModal
          isOpen={isModalOpen}
          onClose={closeModal}
          policy={policy}
          config={config}
          lastUpdate={getLastUpdate()}
        />
      )}
    </>
  );
};
